import { createSlice } from '@reduxjs/toolkit'

interface UserState {
    data: any[]
    loading: boolean
}

const initialState: UserState = {
    data: [],
    loading: false
}

const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        setUserData: (state, action) => {
            state.data = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        clearStates: () => initialState
    }
})

export const { setUserData, setLoading, clearStates } = userSlice.actions
export default userSlice.reducer
